import { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { gotComparedProducts } from '../actions/lister-actions';
import { cookie } from '../utilities/lister-utilities';
import { useEventListener } from './useEventListener';

export function getCompareProductsFromCookie(compareCookie) {
	if (!compareCookie) {
		return [];
	}

	const decodedCookieValue = decodeURIComponent(compareCookie);

	if (!decodedCookieValue.includes('{')) {
		return [];
	}

	const { CookieProducts } = JSON.parse(decodedCookieValue);

	if (!CookieProducts || CookieProducts.length <= 0) {
		return [];
	}

	return CookieProducts.map((item) => ({
		category: item.MainCategoryId,
		sku: item.ProductCode,
	}));
}

export const useCompare = () => {
	const dispatch = useDispatch();

	const getComparedProducts = useCallback(() => {
		const compareCookie = cookie('WEB_COMPAREPRODS').get();

		const compareProducts = getCompareProductsFromCookie(compareCookie);

		dispatch(gotComparedProducts(compareProducts));
	}, [dispatch]);

	useEffect(() => {
		getComparedProducts();
	}, [getComparedProducts]);

	useEventListener('productRemovedFromCompare', getComparedProducts, document);
};

export default useCompare;
